import React from "react";
import FormFieldProps from "features/shared/forms/dynamicForm/models/FormFieldProps";
import SelectInput from "features/shared/components/selectInput/SelectInput";
import { useTranslation } from "react-i18next";
import { getSelectFieldOptions, getTranslatedText, getTranslatedTooltip } from "features/shared/forms/dynamicForm/helpers/dynamicFormHelper";


const SelectBoxField = ({ descriptor, formHandler }: FormFieldProps) => {
  // translations
  const tEnums = useTranslation(descriptor.options?.enumTranslationPath ?? "").t;
  const tLabels = useTranslation("shared\\dynamicForms").t;

  // form hook props
  const { bindFieldNew, errors } = { ...formHandler };

  // render
  return (
    <div className={descriptor.className}>
      <SelectInput
        options={getSelectFieldOptions<any>(descriptor, [], tEnums)}
        label={getTranslatedText(descriptor, "label", tLabels)}
        defaultValueLabel={getTranslatedText(descriptor, "placeholder", tLabels)}
        validationError={errors ? errors[descriptor.name] : undefined}
        tooltip={getTranslatedTooltip(descriptor, tLabels)}
        optionName={descriptor.options?.optionName}
        optionValue={descriptor.options?.optionValue}
        {...bindFieldNew(descriptor.name)}
      />
    </div>
  );
};

export default SelectBoxField;
